import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  DateInput,
  BooleanInput,
  ImageInput,
  ImageField,
  required,
  maxLength,
  useNotify,
  useRedirect,
  regex,
} from "react-admin";
import { RichTextInput } from "ra-input-rich-text";

export const ArticleCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data) => {
    notify("Artículo creado exitosamente", {
      type: "info",
      messageArgs: { smart_count: 1, name: data.title },
    });
    redirect("list", props.basePath || "/articles", data.id, data);
  };

  return (
    <Create {...props} mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <div
          style={{
            display: "flex",
            gap: "10px",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <TextInput
            source="title"
            label="Título"
            validate={[required(), maxLength(255)]}
          />
          <DateInput
            source="publishedAt"
            label="Fecha de Publicación"
            validate={[required()]}
            options={{
              locale: "es-ES",
            }}
          />
        </div>
        <TextInput
          source="slug"
          label="Slug"
          validate={[
            required(),
            maxLength(100),
            regex(
              /^[a-z0-9-]+$/,
              "Solo se permiten letras minúsculas, números y guiones. Sin espacios."
            ),
          ]}
        />
        <BooleanInput source="active" label="Activo" defaultValue={true} />
        <ImageInput
          source="image"
          label="Imagen Principal"
          accept={{
            "image/*": [".png", ".jpg", ".jpeg", ".gif"],
          }}
          placeholder="Haz clic aquí o arrastra y suelta la imagen"
          validate={[required()]}
          options={{
            preventDropOnDocument: true,
            validator: (file) => {
              if (!file.type.startsWith("image/")) {
                return {
                  code: "invalid-file-type",
                  message: "Solo se permiten imágenes",
                };
              }
              return null;
            },
          }}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
        <RichTextInput
          source="content"
          label="Contenido"
          validate={[required()]}
          options={{
            locale: "es-ES",
          }}
        />
      </SimpleForm>
    </Create>
  );
};
